import { defaultFruitType } from "../../../components/scenes/Tenants/Forms/defaultFruitType";
import { getFilledArrayOrDefault } from "../../../utils";
import { DEFECT_POSITION, DEFECT_SEVERITY } from "../../Checks/constants";
import { UNIT_OF_ACCOUNT } from "../../Layers/constants";
import { BaseCheckLocation, CheckLocation, LayerTypeConfig, Stage } from "./constantsTyped";
import { ALL_FRUIT } from "./fruitNames";
import { onchange_callbacks } from "./onchange_callbacks/onchange_callbacks";
import { onload_layer_callbacks } from "./onload_layer_callbacks/onload_layer_callbacks";

// summary fields
const CHECK_LOCATION = "check_location";
const LAYER_TYPE = "layer_type";
const STAGE = "stage";
const PDF_REPORT = "pdf_report";
const FRUIT_TYPE = "fruit_type";
const COLOR_CODE = "color_code";
const ROOT = "root";
export const CONFIG_TYPES = {
    LAYER_TYPE,
    STAGE,
    CHECK_LOCATION,
    PDF_REPORT,
    FRUIT_TYPE,
    COLOR_CODE,
    ROOT,
};

// TODO: convert to structure like actions/layer/fields
export const summary_field_avocado_index = "summary_field_avocado_index";
export const summary_field_avos_firmness = "summary_field_avos_firmness";
export const summary_field_avos_firmness_raw = "summary_field_avos_firmness_raw";
export const summary_field_pressure = "summary_field_pressure";
export const summary_field_pressure_prediction = "summary_field_pressure_prediction";
export const summary_field_external_defects = "summary_field_external_defects";
export const summary_field_internal_defects = "summary_field_internal_defects";
export const summary_field_major_defects = "summary_field_major_defects";
export const summary_field_minor_defects = "summary_field_minor_defects";
export const summary_field_color = "summary_field_color";
export const summary_field_weight = "summary_field_weight";
export const summary_field_weight_kg = "summary_field_weight_kg";
export const summary_field_manual_quality = "summary_field_manual_quality";
export const summary_field_atron_weight = "summary_field_atron_weight";
export const summary_field_brix = "summary_field_brix";
export const summary_field_dry_matter = "summary_field_dry_matter";
export const summary_field_dry_matter_felix = "summary_field_dry_matter_felix";
export const summary_field_dry_matter_class = "summary_field_dry_matter_class";
export const summary_field_internal_color = "summary_field_internal_color";
export const summary_field_external_color = "summary_field_external_color";
export const summary_field_is_shiny = "summary_field_is_shiny";
export const summary_field_maturity = "summary_field_maturity";
export const summary_field_temperature = "summary_field_temperature";
export const summary_field_fruit_variety = "summary_field_fruit_variety";
export const summary_field_predicted_ripening_stage = "summary_field_predicted_ripening_stage";
export const summary_field_manual_ripening_stage = "summary_field_manual_ripening_stage";
export const summary_field_ripening_stage_firmness = "summary_field_ripening_stage_firmness";
export const summary_field_pressure_color_code_by_firmness_class = "summary_field_pressure_color_code_by_firmness_class";
export const summary_field_taste = "summary_field_taste";
export const summary_field_penetro_pressures = "summary_field_penetro_pressures";
export const summary_field_durometer_pressures = "summary_field_durometer_pressures";
export const summary_field_pressure_classes = "summary_field_pressure_classes";
export const summary_field_plu = "summary_field_plu";
export const summary_field_box_size = "summary_field_box_size";
export const summary_field_fruit_firmness_class = "summary_field_fruit_firmness_class";
export const summary_field_underweight = "summary_field_underweight";
export const summary_field_mouth_ripeness = "summary_field_mouth_ripeness";
export const summary_field_flavour_nuttiness = "summary_field_flavour_nuttiness";
export const summary_field_flavour_creamy = "summary_field_flavour_creamy";
export const summary_field_lab_check_dm_avg = "summary_field_lab_check_dm_avg";
export const summary_field_gross_weight = "summary_field_gross_weight";
export const summary_field_net_weight = "summary_field_net_weight";
export const summary_field_caliber = "summary_field_caliber";
export const summary_field_first_impression = "summary_field_first_impression";
export const summary_field_texture_consistency = "summary_field_texture_consistency";
export const summary_field_colors = "summary_field_colors";
export const summary_field_maturity_string = "summary_field_maturity_string";
export const summary_field_box_weight_empty = "summary_field_box_weight_empty";
export const summary_field_box_weight_gross = "summary_field_box_weight_gross";
export const summary_field_box_weight_net = "summary_field_box_weight_net";
export const summary_field_box_index = "summary_field_box_index";
export const summary_field_fruit_diameter = "summary_field_fruit_diameter";
export const summary_field_lenticel = "summary_field_lenticel";
export const summary_field_translucency = "summary_field_translucency";
export const summary_field_remarks = "summary_field_remarks";
export const summary_field_acidity = "summary_field_acidity";

export const summary_fields = [
    summary_field_avocado_index,
    summary_field_avos_firmness,
    summary_field_avos_firmness_raw,
    summary_field_pressure,
    summary_field_pressure_prediction,
    summary_field_external_defects,
    summary_field_internal_defects,
    summary_field_major_defects,
    summary_field_minor_defects,
    summary_field_color,
    summary_field_weight,
    summary_field_weight_kg,
    summary_field_manual_quality,
    summary_field_atron_weight,
    summary_field_brix,
    summary_field_dry_matter,
    summary_field_dry_matter_felix,
    summary_field_dry_matter_class,
    summary_field_internal_color,
    summary_field_external_color,
    summary_field_is_shiny,
    summary_field_maturity,
    summary_field_temperature,
    summary_field_fruit_variety,
    summary_field_predicted_ripening_stage,
    summary_field_manual_ripening_stage,
    summary_field_ripening_stage_firmness,
    summary_field_pressure_color_code_by_firmness_class,
    summary_field_taste,
    summary_field_penetro_pressures,
    summary_field_durometer_pressures,
    summary_field_pressure_classes,
    summary_field_plu,
    summary_field_box_size,
    summary_field_fruit_firmness_class,
    summary_field_underweight,
    summary_field_mouth_ripeness,
    summary_field_flavour_nuttiness,
    summary_field_flavour_creamy,
    summary_field_lab_check_dm_avg,
    summary_field_gross_weight,
    summary_field_net_weight,
    summary_field_caliber,
    summary_field_first_impression,
    summary_field_texture_consistency,
    summary_field_colors,
    summary_field_maturity_string,
    summary_field_box_weight_empty,
    summary_field_box_weight_gross,
    summary_field_box_weight_net,
    summary_field_box_index,
    summary_field_fruit_diameter,
    summary_field_lenticel,
    summary_field_translucency,
    summary_field_remarks,
    summary_field_acidity,
];

export const atron_pressures_median = "atron_pressures_median";
export const atron_pressures = "atron_pressures";

export const fruit_fields = [
    atron_pressures_median,
    atron_pressures,

];

// Add check pages with their titles
// TODO: convert to enum
export const path_atron_results = "atron-results";
export const path_find_pallet = "find-pallet";
export const path_atron = "scanning";
export const path_mangos = "mangos";
export const path_form = "form";

export const path_external_quality_check = "external-quality-check";
export const path_fta_input = "fta-input";
export const path_weight_input = "weight-input";
export const path_weight_input_kg = "weight-input-kg";
export const path_internal_quality_check = "internal-quality-check";
export const path_pressure_validation = "pressure-validation";
export const path_color_check = "color-check";
export const path_internal_color_check = "internal-color-check";
export const path_brix_input = "brix-input";
export const path_dry_matter = "dry-matter";
export const path_maturity = "maturity-input";
export const path_temperature = "temperature-input";
export const path_power_bi = "power-bi";
export const path_manual_check = "manual-check";
export const path_secondary_manual_check = "secondary-manual-check";
export const path_manual_or_with_mini = "manual-or-with-mini";
export const path_manual_fruit_form = "manual-check"; //  renamed it to manual-check since path_manual_fruit_form or path_manual_check are the same
export const path_visual_check = "visual-check";
export const path_secondary_visual_check = "secondary-visual-check";
export const path_results_with_form = "results-with-form";
export const path_summary = "summary";
export const path_taste = "taste";
export const path_durometer = "durometer";
export const path_penetrometer = "penetrometer";
export const path_has_internal_quality_check = "has-internal-quality-check";
export const path_ask_quality = "ask-quality";
export const path_fruit_images = "fruit-images";
export const path_plu = "path-plu";
export const path_pressure_lbs = "path_pressure_lbs";
export const path_pressure_kg = "path_pressure_kg";
export const path_pit_size = "path_pit_size";
export const path_advance_ripening = "advance_ripening";
export const path_send_check_status_to_tenant = "send-status-to-tenant";

// QC pages
export const pages = {
    [path_find_pallet]: "Search Pallet",
    [path_atron]: "Scan",
    [path_mangos]: "Scan", // only collecting data
    [path_atron_results]: "Scan", // Collecting data AND showing results
    [path_secondary_manual_check]: "Secondary Manual Check",
    [path_form]: "Feedback Form",
    [path_internal_quality_check]: "Internal Quality Check",
    [path_external_quality_check]: "External Quality Check",
    [path_fta_input]: "Pressure Input",
    [path_weight_input]: "Weight Input",
    [path_summary]: "Summary",
    [path_pressure_validation]: "Pressure validation",
    [path_color_check]: "External Color Check",
    [path_internal_color_check]: "Internal Color Check",
    [path_brix_input]: "Brix input",
    [path_dry_matter]: "Dry matter",
    [path_maturity]: "Maturity",
    [path_temperature]: "Temperature",
    [path_penetrometer]: "Penetrometer",
    [path_durometer]: "Durometer",
    [path_fruit_images]: "Images",
    [path_pit_size]: "Pit size",
    [path_visual_check]: "Visual Check",
    [path_secondary_visual_check]: "Secondary Visual Check",
    [path_send_check_status_to_tenant]: "Send Check Status to Tenant"
};

// Default translations
export const lang = {
    pressure: "Pressure",
};

export const default_location_config: BaseCheckLocation = {
    show_atron_color: false,
    show_atron_results_bottom_summary: true,
    fruit_types: ALL_FRUIT,
};

export const ripening_colors = {
    RTE: "#9A6804",
    Triggered: "#049510",
    Hard: "#015D09",
    "RTE+": "#885C02",
    "Triggered+": "#017F0B",
    Soft: "brown",
    Ripe: "#049510",
    "Nearly ripe": "#D9B300",
    Overripe: "#FFA500",
    Medium: "#049510",
    Firm: "#D9B300",
    Hard_Mission: "#D64550",
    Red: "#FF0000",
    Green: "#089000"
};

// TODO: still being used in legacy fruit table. remove at some point, discuss with agis
// * classes based on mini firmness
export const firmness_classes = [
    {
        gte: false,
        lt: 10,
        label: "Overripe",
        color: ripening_colors.Overripe
    },
    {
        gte: 10,
        lt: 31,
        label: "Soft",
        color: ripening_colors.Soft
    },
    {
        gte: 31,
        lt: 50,
        label: "Medium",
        color: ripening_colors.Medium
    },
    {
        gte: 50,
        lt: 71,
        label: "Firm",
        color: ripening_colors.Firm
    },
    {
        gte: 71,
        lt: 200,
        label: "Hard",
        color: ripening_colors.Hard
    },
];

export const pressure_classes = [
    {
        gte: false,
        lt: 7,
        label: "Ripe",
        color: ripening_colors.Ripe
    },
    {
        gte: 7.1,
        lt: 12,
        label: "Nearly ripe",
        color: ripening_colors["Nearly ripe"]
    },
    {
        gte: 12,
        lt: false,
        label: "Hard",
        color: ripening_colors.Hard
    },
];

export const headerLinks = {
    home: "home",
    settings: "settings",
    // checks: "checks",
    addCheck: "addCheck",
    logout: "logout",
    insights: "insights",
    labelling: "labelling",
    packinglist: "packinglist",
    deviceManagement: "deviceManagement",
    tenants: "tenants",
    ripening: "ripening",
    waste: "waste",
    switchTenant: "switchTenant",
    mailbox: "mailbox",
    admin: "admin",
    signals: "signals",
    sourcingList: "sourcingList",
    tabCategoryOperation: "tab_category.operation",
    tabCategoryStock: "tab_category.stock",
    tabCategoryQCPlanning: "tab_category.qc_planning",
    tabCategoryQCReport: "tab_category.report",
    tabCategoryTransit: "tab_category.transit",
    tabCategoryRipeningPlanning: "tab_category.ripening_planning",
    tabCategoryA: "tab_category.category_a",
    tabCategoryB: "tab_category.category_b",
    tabCategoryC: "tab_category.category_c",
    tabCategoryD: "tab_category.category_d",
};


export const baseConfig: any = {
    form_options: {},
    fruit_types: [],
    check_locations: [],
    facility_locations: [],
    layer_types: [],
    pdf_reports: [],
    stages: [],
    get_fruit_types() {
        return this.fruit_types;
    },
    get_fruit_type(fruit_type: string) {
        return this.fruit_types.find((i: any) => i.value === fruit_type) || defaultFruitType;
    },
    get_fruit_type_external_colors(pallet) {
        const fruit_type = this.get_fruit_type(pallet.fruit_type);
        if (fruit_type.external_colors) {
            return fruit_type.external_colors;
        }
        return false;
    },
    get_fruit_type_internal_colors(pallet) {
        const fruit_type = this.get_fruit_type(pallet.fruit_type);
        if (fruit_type.internal_colors) {
            return fruit_type.internal_colors;
        }
        return false;
    },
    get_ripening_classes(pallet, fieldname = "pressure_avg") {
        const fruit_type = this.get_fruit_type(pallet.fruit_type);
        return getFilledArrayOrDefault(fruit_type.ripening_fields).find((i) => i.fieldname_getter === fieldname)?.categories || pressure_classes;
    },
    // default_fruit_type: AVOCADO_FRUIT, // This stopped working ?
    default_fruit_type: "avocado",
    has_purchase_order_number: false,
    default_manual: false,
    can_do_manual_check: false,
    summary_collapsed: true,
    ripening_target_options: false,
    indicate_soft_avocado_at_internal: false,
    indicate_quality_at_defects: true,
    suggest_color_stage: false,
    default_location: "intake",
    research_mode: true,
    bakker: false,
    invalidate_20x_firmness: true,
    show_device_toggle: false,

    pages,
    lang,
    first_check_page(layer, check, currentPage) {
        if (!currentPage || !layer.type) {
            return false;
        }

        const checkLocation = this.get_check_type_config(layer, check);

        if (checkLocation) {
            const { flow } = checkLocation;
            const first = flow?.[0]?.path;

            if (first === currentPage) {
                return false;
            }

            return { text: this.pages[first], path: first };
        }

        return false;
    },
    next_check_page(layer, check, currentPage) {
        if (!currentPage || !layer.type) {
            return false;
        }
        const checkLocation = this.get_check_type_config(layer, check);
        if (checkLocation) {
            const flow = checkLocation?.flow?.map((f) => f.path);
            const index = flow.indexOf(currentPage);

            if (index > -1) {
                const next = flow[index + 1] || false;
                if (next === false) {
                    return false;
                }
                return { text: this.pages[next], path: next };
            }
        }
        return false;
    },
    // after_device_step(layer, check) {
    //     const checkLocation = this.get_check_type_config(layer, check);
    //     if (checkLocation) {
    //         const flow = checkLocation?.flow?.map((f) => f.path);
    //         const next = flow[1];
    //         return { text: this.pages[next], path: next };
    //     }
    //     return false;
    // },
    prev_check_page(layer, check, currentPage) {
        if (!currentPage || !layer?.type) {
            return false;
        }
        const checkLocation = this.get_check_type_config(layer, check);

        if (checkLocation) {
            const flow = checkLocation?.flow?.map((f) => f.path);
            const index = flow.indexOf(currentPage);

            if (index > 0) {
                const prev = flow[index - 1] || false;
                if (prev === false) {
                    return false;
                }
                // advance ripening is a special case and actual a summary page, is handled seperaterly in ManualCheckNavButtons
                if (prev === path_advance_ripening) {
                    return false;
                }

                return { text: this.pages[prev], path: prev };
            }
        }
        return false;
    },
    get_layer_pdf_reports(layer) {
        return this.applyDisplayFilter(this.pdf_reports, { fruit_type: layer.fruit_type, layer }).filter((i) => i.layer_type === layer.type);
    },

    get_pdf_report(layer, report_value) {
        const report = this.pdf_reports.find((i) => i.value === report_value);
        if (!report) {
            return undefined;
        }
        const filter = { layer_type: layer.type, fruit_type: layer.fruit_type, layer };
        return {
            ...report,
            children_table_fields: this.applyDisplayFilterLayerFields(report.children_table_fields, filter),
            // Keep raw so consumers that render per-pallet pages can evaluate meta_conditions per pallet.
            children_check_summary_meta_fields: report.children_check_summary_meta_fields,
            check_meta_fields: this.applyDisplayFilterLayerFields(report.check_meta_fields, filter),
            pallet_meta_fields: this.applyDisplayFilterLayerFields(report.pallet_meta_fields, filter),
            defect_groups: this.applyDisplayFilterFields(report.defect_groups, filter),
            dynamic_sections: this.applyDisplayFilterFields(report?.dynamic_sections, filter),
        };
    },


    // * Get locations for layer, attributes will be unfiltered
    get_check_types_config(layer) {
        // * only filter on layer properties here
        // * Use layer's facility (from its latest location) instead of the user's facility
        const layerFacility = layer.latest_location?.facility;
        const filter = { layer_type: layer.type, fruit_type: layer.fruit_type, layer, facilities: layerFacility ? [layerFacility] : undefined };
        return this.applyDisplayFilter(this.check_locations, filter).map((rawLocation) => this.filter_location_fields(rawLocation, filter)) as CheckLocation[];

    },

    // * Get location config for check on layer. Will filter all fields for you
    get_check_type_config(layer, check) {

        const rawLocation = this.check_locations.find((check_config) => check_config.value === check.location);
        if (!rawLocation) {
            return undefined;
        }
        const filter = { layer_type: layer.type, fruit_type: layer.fruit_type, is_manual: check.is_manual, layer, check };
        return this.filter_location_fields(rawLocation, filter) as CheckLocation;

    },
    // * Get unit of account for check on layer. Checks check_location first, then fruit_type config, then defaults to "fruit"
    get_check_unit_of_account(layer, check) {
        const location = this.get_check_type_config(layer, check);
        if (location?.unit_of_account) {
            return location.unit_of_account;
        }
        const fruitType = this.get_fruit_type(layer?.fruit_type);
        if (fruitType?.unit_of_account) {
            return fruitType.unit_of_account;
        }
        return UNIT_OF_ACCOUNT.FRUIT;
    },
    filter_location_fields(rawLocation, filter) {
        // * setup forms, summary fields etc etc
        try {
            return {
                ...rawLocation,
                flow: this.applyDisplayFilterFields(rawLocation.flow, filter), // For now  only interested in the legacy path
                inline_form: this.applyDisplayFilterFields(rawLocation.inline_form, filter).map((i) => i.field_type), // For now  only interested in the legacy path
                meta_form_summary: this.applyDisplayFilterFields(rawLocation.meta_form_summary, filter), // returns form fields
                meta_form_layer: this.applyDisplayFilterFields(rawLocation.meta_form_layer, filter), // returns form fields
                pre_check_form: this.applyDisplayFilterFields(rawLocation.pre_check_form, filter), // returns form fields
                visual_check_form: this.applyDisplayFilterFields(rawLocation.visual_check_form, filter), // returns form fields
                secondary_visual_check_form: this.applyDisplayFilterFields(rawLocation.secondary_visual_check_form, filter), // returns form fields
                summary_fruit_fields: this.applyDisplayFilterFields(rawLocation.summary_fruit_fields, filter).map((i) => i.field_id), // For now  only interested in the legacy summary_field id
                summary_fruit_fields_v2: this.applyDisplayFilterLayerFields(rawLocation.summary_fruit_fields_v2, filter), // returns summary fields for specific fruit types
                summary_layer_fields_1: this.applyDisplayFilterLayerFields(rawLocation.summary_layer_fields_1, filter), // returns layer fields_1
                summary_layer_fields_2: this.applyDisplayFilterLayerFields(rawLocation.summary_layer_fields_2, filter),
                summary_layer_fields_3: this.applyDisplayFilterLayerFields(rawLocation.summary_layer_fields_3, filter),
                summary_layer_fields_4: this.applyDisplayFilterLayerFields(rawLocation.summary_layer_fields_4, filter),
                summary_layer_fields_pdf: this.applyDisplayFilterLayerFields(rawLocation.summary_layer_fields_pdf, filter),
                summary_min_max_breakdown: this.applyDisplayFilterFields(rawLocation.summary_min_max_breakdown, filter), // returns min max breakdowns for specific fruit types
                summary_category_charts: this.applyDisplayFilterFields(rawLocation.summary_category_charts, filter), // returns category charts for specific fruit types
                // Return the first set of settings that matches the fruit filter
                pressure_calibration_settings: this.applyDisplayFilterFields(rawLocation.pressure_calibration_settings, filter)?.[0] || false, // returns pressure calibration settings for specific fruit types
                meta_form_advance_ripening: this.applyDisplayFilterFields(rawLocation.meta_form_advance_ripening, filter), // returns form fields
                advance_ripening_classes_form: this.applyDisplayFilterFields(rawLocation.advance_ripening_classes_form, filter), // returns form fields
                advance_ripening_start_form: this.applyDisplayFilterFields(rawLocation.advance_ripening_start_form, filter), // returns form fields
                visual_check_defect_form: this.applyDisplayFilterFields(rawLocation.visual_check_defect_form, filter), // returns form fields
                secondary_visual_check_defect_form: this.applyDisplayFilterFields(rawLocation.secondary_visual_check_defect_form, filter), // returns form fields
                defect_groups: this.applyDisplayFilterFields(rawLocation.defect_groups, filter),
            };
        } catch (e: any) {
            console.error("rawLocation", rawLocation); // eslint-disable-line no-console
            throw new Error(e);
            // throw new Error("Error filtering location fields.");

        }
    },
    get_fruit_form(layer, check, fruit) {
        const location = this.get_check_type_config(layer, check);
        return this.applyDisplayFilterFields(location?.fruit_form, { layer_type: layer.type, fruit_type: layer.fruit_type, is_manual: check.is_manual, layer, check, fruit });
    },
    get_secondary_fruit_form(layer, check, fruit) {
        const location = this.get_check_type_config(layer, check);
        return this.applyDisplayFilterFields(location?.secondary_fruit_form, { layer_type: layer.type, fruit_type: layer.fruit_type, is_manual: check.is_manual, layer, check, fruit });
    },
    get_check_required_images(layer, check) {
        const location = this.get_check_type_config(layer, check);
        const layer_config = this.get_layer_config(layer);
        const required_images = location?.required_images || layer_config?.show_images || [];
        // Filter based on display_filter and meta_conditions
        return this.applyDisplayFilterFields(required_images, {
            layer_type: layer.type,
            fruit_type: layer.fruit_type,
            is_manual: check.is_manual,
            layer,
            check
        });
    },
    get_fruit_required_images(layer, check, fruit) {
        const location = this.get_check_type_config(layer, check);
        const required_fruit_images = location?.required_fruit_images || [];
        // Filter based on display_filter and meta_conditions
        return this.applyDisplayFilterFields(required_fruit_images, {
            layer_type: layer.type,
            fruit_type: layer.fruit_type,
            is_manual: check.is_manual,
            layer,
            check,
            fruit
        });
    },
    get_defect_positions() {
        const configuredPositions = getFilledArrayOrDefault(this.root_config?.defect_positions, []);
        const defaultValues = Object.values(DEFECT_POSITION);

        // If configured positions exist, extract options and values from the OptionsConfigForm structure
        if (configuredPositions.length > 0) {
            const options = configuredPositions
                .map((item) => item.field || item)
                .filter((field) => field?.value)
                .map((field) => ({
                    value: field.value,
                    label: field.label || field.value
                }));
            const values = options.map((opt) => opt.value);
            return { options, values };
        }

        // Fallback to enum values, creating options with both value and label as the enum value
        const options = defaultValues.map((value) => ({ value, label: value }));
        const values = defaultValues;
        return { options, values };
    },
    get_defect_severities() {
        const configuredSeverities = getFilledArrayOrDefault(this.root_config?.defect_severities, []);
        const defaultValues = Object.values(DEFECT_SEVERITY);

        // If configured severities exist, extract options and values from the OptionsConfigForm structure
        if (configuredSeverities.length > 0) {
            const options = configuredSeverities
                .map((item) => item.field || item)
                .filter((field) => field?.value)
                .map((field) => ({
                    value: field.value,
                    label: field.label || field.value
                }));
            const values = options.map((opt) => opt.value);
            return { options, values };
        }

        // Fallback to enum values, creating options with both value and label as the enum value
        const options = defaultValues.map((value) => ({ value, label: value }));
        const values = defaultValues;
        return { options, values };
    },
    is_location_calibrated(location, layer) {
        const { pressure_calibration_settings } = location;
        const requested_calibration_stage = pressure_calibration_settings?.calibration_stage;
        // console.log("pressure_calibration_settings", pressure_calibration_settings);
        // console.log("requested_calibration_stage", requested_calibration_stage);
        // console.log("layer.calibrated_stages", layer.calibrated_stages);
        return (layer.calibrated_stages || []).some((i) => i.calibration_stage === requested_calibration_stage);
    },
    // not sure if this is good....less verbosity, but also less explicit.
    default_location_config,
    get_stage(stage) {
        return (this.stages.find((i) => i.value === stage) || this.stages[0]) as Stage;
    },

    // * This will get you the config for this layer, with attributes filtered
    get_layer_config(layer) {
        if (!layer?.type) {
            return undefined;
        }

        const rawLayer = this.get_raw_layer_config(layer.type);
        if (!rawLayer) {
            return undefined;
        }
        const filter = { layer_type: layer.type, fruit_type: layer.fruit_type, layer };

        return {
            ...rawLayer,
            meta_display: this.applyDisplayFilterLayerFields(rawLayer.meta_display, filter),
            meta_form: this.applyDisplayFilterFields(rawLayer.meta_form, filter),
            // show_images: this.applyDisplayFilterFields(rawLayer.show_images, filter), // not really sure if this is used or not
            special_actions: this.applyDisplayFilterFields(rawLayer.special_actions, filter),
            show_metric_cards: this.applyDisplayFilterFields(rawLayer.show_metric_cards, filter),
            show_arrival_check: rawLayer.show_arrival_check ? { ...rawLayer.show_arrival_check, fields: this.applyDisplayFilterLayerFields(rawLayer.show_arrival_check?.fields, filter) } : rawLayer.show_arrival_check,
            show_children: rawLayer.show_children ? { ...rawLayer.show_children, fields: this.applyDisplayFilterLayerFields(rawLayer.show_children?.fields, filter) } : rawLayer.show_children,
            show_advance_ripening: rawLayer.show_advance_ripening ? { ...rawLayer.show_advance_ripening, fields: this.applyDisplayFilterLayerFields(rawLayer.show_advance_ripening?.fields, filter) } : rawLayer.show_advance_ripening,
        };
    },
    // Use this if you just want the raw config for the type:string
    get_raw_layer_config(layer_type) {
        if (!layer_type) {
            return this.layer_types[0] as LayerTypeConfig;
        }
        return (this.layer_types.find((i: any) => i.value === layer_type) ?? this.layer_types[0]) as LayerTypeConfig;
    },
    get_raw_check_location(check_location) {
        return (this.check_locations.find((i: any) => i.value === check_location) ?? this.check_locations[0]);
    },
    translate_atron_color_to_manual_color_stage(atron_color) {
        if (atron_color === 2 || atron_color === 4) {
            return 3;
        }
        return atron_color;
    },
    firmness_to_display_value: (firmness) => firmness,
    headerSecondaryLinks: [headerLinks.settings, headerLinks.logout],
    headerMainLinks: [headerLinks.home],
    barcode_filter: (scanned) => scanned,
    use_barcode_scanner: true,
    onchange_callbacks,
    onload_layer_callbacks,
    get_onchange_callback(callback_ref) {
        return this.onchange_callbacks[callback_ref];

    },
    get_facility_location(location_id) {
        return this.facility_locations.find((i) => i.location_id === location_id);
    },
};

export const tenantIds = {
    ExperienceData: "a6aff297-ac1b-4e81-88a6-420591d31f31",
    FruitSolute: "54bb5edb-b95d-4376-b064-1d6de60c1708",
    Bakker: "fbd6b96d-25a4-4898-a042-deab47c2bb5d",
    BakkerSAP: "fe2d884e-ee5a-4bb1-8509-d198ef8ea0a6",
    BakkerBelgium: "c4169992-7b9a-4ac2-9c57-3bbbf0172cf4",
    NaturesPrides: "fd331325-68a3-4129-9cf9-3e92e3799948",
    OmerDecugis: "0f4cb0a5-55c6-4321-8a19-6c0c09019904",
    GeorgesHelfer: "840d4805-f9b6-4e4a-b943-8d4ca54a389a",
    TheAvocadoCompany: "f0616485-c188-4f46-af85-e393641a79b1",
    SpecialFruit: "961bcfeb-0a01-40c0-9314-05f1e9c8b32d",
    FrutosGuadalajara: "add258f0-dd3b-4de7-a499-584c0c2065fe",
    SHPTropical: "f517b5e2-0a6b-4938-b493-57d906a30855",
    TropsSpain: "010f2569-9dc1-41e9-89da-9e170b92e3e8",
    EDMissionBreda: "03c78ada-9b11-4134-977a-cf3e1128e8ff",
    ActualMission: "8e1f271d-c4fc-4d96-9ac2-9344a044e1e6",
    DoleExotics: "f4b8baea-e6cf-4c7e-9e84-f10fdaa21bc0",
    DoleEurope: "a588906b-00ef-46e6-8992-13fe8b1e437b",
    MasterTenant: "master_tenant",
    Agrovision: "894b0d51-3620-4c7e-ae4e-159b176c0b7a",
    FruitifyExperts: "4277aabc-eee1-4325-961a-d60f8570c4a1",
    DeLaat: "2a15ddc0-0aee-4129-b619-9565db2de1d3",
    colruyt: "c0c5d583-1daf-41b8-b2f9-3590cb8a3856",
    EyeOnProducer: "f09bfe69-5ede-4e92-a61c-d070a7b65454",
    GlobalPacific: "7ebcd8e4-9247-4243-80f0-ffd4b41da836",
    Mehadrin_mtexukcom: "a0ef7762-3dac-476f-9b6f-26f37e25cca6",
    Mehadrin_mtexnl: "436bcef8-8436-463b-8946-0e5aa737cd22",
    Mehadrin_isr: "40a608e3-1b9f-4cae-bd85-faaeb170cb8e",
    // * Internal tenants
    repair_shop: "repair-shop",
    master_tenant: "master_tenant",
};


export const DeviceResultActions = {
    ask_pressure: "ask_pressure",
    inline_form: "inline_form",
    setup_pressure_calibration: "setup_pressure_calibration",
    setup_pressure_calibration_with_form: "setup_pressure_calibration_with_form",
    pressure_advice: "pressure_advice",
    calibrate_after_n_fruits: "calibrate_after_n_fruits",
    none: "none"
};
